import { useBoundStore } from '@Store/useBoundStore';
import { HttpService } from './httpService';

export enum ConsentTypes {
  SUBMIT_YOUR_APPLICATION = 'SUBMIT_YOUR_APPLICATION',
  GET_STARTED = 'GET_STARTED',
}

export const getTermsAndConditions = async (type: ConsentTypes) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;
  const url = isEmbedded
    ? `v4/secureonboarding/partner/user/${customerId}/termsAndCondition?event=${type}`
    : `v4/secureonboarding/${customerId}/termsAndCondition?event=${type}`;

  const { data } = await HttpService.get(url);
  return data;
};
